import cookieManager from "../../../../utils/cookieManager";
import axios from "axios";
import SalesPerformanceChartActions from "../../../../reducers/modules/chart/sales-performance/actions";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Navigate } from "react-router-dom";
import i18n from "../../../../i18n";

const MySwal = withReactContent(Swal);
const url = process.env.REST_URL + "chart/sales-performance-chart";

export default class SalesPerformanceChartMiddleware {
  

  static setData(params) {
    return (dispatch) => {
      dispatch(SalesPerformanceChartActions.process());
      SalesPerformanceChartMiddleware.showData(dispatch, params);
    };
  }

  static setDataTable(params) {
    return (dispatch) => {
      dispatch(SalesPerformanceChartActions.process());
      SalesPerformanceChartMiddleware.showDataTable(dispatch, params);
    };
  }
  static setDataMonitor(params) {
    return (dispatch) => {
      dispatch(SalesPerformanceChartActions.process());
      SalesPerformanceChartMiddleware.showDataMonitor(dispatch, params);
    };
  }

  static setDataTarget(params) {
    return (dispatch) => {
      dispatch(SalesPerformanceChartActions.process());
      SalesPerformanceChartMiddleware.showDataTarget(dispatch, params);
    };
  }

  static setDataDistribution(params) {
    return (dispatch) => {
      dispatch(SalesPerformanceChartActions.process());
      SalesPerformanceChartMiddleware.showDataDistribution(dispatch, params);
    };
  }

  static reset() {
    return (dispatch) => {
      dispatch(SalesPerformanceChartActions.reset());
    };
  }

  static resetList() {
    return (dispatch) => {
      dispatch(SalesPerformanceChartActions.resetList());
    };
  }

  static getHelper(params = null) {
    return (dispatch) => {
      SalesPerformanceChartMiddleware.showHelper(dispatch, params);
    };
  }

  static getToken() {
    return cookieManager.getUserToken();
  }

  static showHelper(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${SalesPerformanceChartMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-helper-sales-chart",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(SalesPerformanceChartActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        SalesPerformanceChartMiddleware.alertHendler(dispatch, error);
      });
  }

  
  static showData(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${SalesPerformanceChartMiddleware.getToken()}`,
      },
      url: url,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
            dispatch(SalesPerformanceChartActions.list(response.data.result)
            );
        }
      })
      .catch((error) => {
        SalesPerformanceChartMiddleware.alertHendler(dispatch, error);
      });
  }

  static showDataTable(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${SalesPerformanceChartMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "chart/sales-performance-table",
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
            dispatch(SalesPerformanceChartActions.listTable(response.data.result)
            );
        }
      })
      .catch((error) => {
        SalesPerformanceChartMiddleware.alertHendler(dispatch, error);
      });
  }

  static showDataTarget(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${SalesPerformanceChartMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "chart/sales-performance-target",
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
            dispatch(SalesPerformanceChartActions.listTarget(response.data.result)
            );
        }
      })
      .catch((error) => {
        SalesPerformanceChartMiddleware.alertHendler(dispatch, error);
      });
  }

  static showDataDistribution(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${SalesPerformanceChartMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "chart/sales-performance-distribution",
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
            dispatch(SalesPerformanceChartActions.listDistribution(response.data.result)
            );
        }
      })
      .catch((error) => {
        SalesPerformanceChartMiddleware.alertHendler(dispatch, error);
      });
  }

  static showDataMonitor(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${SalesPerformanceChartMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "chart/sales-performance-daily-monitor",
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
            dispatch(SalesPerformanceChartActions.listMonitor(response.data.result)
            );
        }
      })
      .catch((error) => {
        SalesPerformanceChartMiddleware.alertHendler(dispatch, error);
      });
  }

  static saveUpdate(dispatch, params, post, search) {
    axios({
      method: "PUT",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${SalesPerformanceChartMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            SalesPerformanceChartActions.process(),
            SalesPerformanceChartMiddleware.showlist(dispatch, search)
          );
          dispatch(SalesPerformanceChartActions.success());
          SalesPerformanceChartMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Update Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        SalesPerformanceChartMiddleware.alertHendler(dispatch, error);
      });
  }
  static alertHendler(
    dispatch,
    result,
    isSwal = false,
    extraMessage = "",
    type = "error"
  ) {
    if (type == "error") {
      if (result.response) {
        const status = result.response.status;
        switch (status) {
          case 500:
            if (isSwal) {
              const data = result.response.data;
              MySwal.hideLoading();
              MySwal.update({
                title: "Error",
                html: i18n.t(data.message),
                icon: "error",
                showConfirmButton: true,
              })
              const search = {limit: 10}
                dispatch(
                  SalesPerformanceChartActions.process(),
                  SalesPerformanceChartMiddleware.showlist(dispatch, search)
                );
          
            } else {
              const data = result.response.data;
              dispatch(SalesPerformanceChartActions.error(data.error));
            }
            break;
          case 403:
            console.log("Error 403");
            break;
          case 404:
            console.log("Error 404");
            break;
          case 401:
            const data = result.response.data;
            MySwal.fire({
              title: "Login Invalid",
              html: data.error,
              icon: "error",
              showConfirmButton: true,
            }).then((result) => {
              if (result.isConfirmed) {
                <Navigate to="/login"></Navigate>;
              }
            });
            break;
        }
      } else if (result.request) {
        MySwal.fire({
          title: "Internal Server Error",
          html: "Please info your Developer to fix this",
          icon: "error",
          showConfirmButton: true,
        });
        dispatch(SalesPerformanceChartActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", result.message);
      }
    } else {
      MySwal.fire({
        title: "Success",
        html: extraMessage,
        icon: "success",
        showConfirmButton: true,
      });
    }
  }
}
